import request from '@/utils/request'

export function memberList(query) {
  return request({
    url: '/api/member/list',
    method: 'post',
    params: query
  })
}

export function memberFrozen(data) {
  return request({
    url: '/api/member/frozen',
    method: 'post',
    params: data
  })
}

export function createMember(data) {
  return request({
    url: '/api/member/add',
    method: 'post',
    data
  })
}

export function updateMember(data) {
  return request({
    url: '/api/member/update',
    method: 'post',
    data
  })
}

export function addCharge(data) {
  return request({
    url: '/api/member/charge',
    method: 'post',
    data
  })
}

export function addRefund(data) {
  return request({
    url: '/api/member/refund',
    method: 'post',
    data
  })
}

export function memberClose(data) {
  return request({
    url: '/api/member/close',
    method: 'post',
    data
  })
}

export function memberDetail(data) {
  return request({
    url: '/api/member/detail',
    method: 'post',
    data
  })
}

export function companyCharge(data) {
  return request({
    url: '/api/member/companyCharge',
    method: 'post',
    data
  })
}

export function fetchTotalMember(data) {
  return request({
    url: '/api/member/fetchTotalMember',
    method: 'post',
    data
  })
}
